import { COLORS } from '../../../utils/colors';
import theme from '../../../theme';

export const useTranscriptStyles = () => {
  return {
    baseButton: {
      fontWeight: 500,
      color: '#FF6E00',
      textTransform: 'none',
      margin: '0 10px',
    },
    viewTitle: {
      borderTop: '0.0625rem solid #ebebeb',
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'flex-end',
      borderBottom: `0.0625rem solid ${theme.palette.divider}`,
      fontWeight: 500,
      pb: '0.1125rem',
      background: '#fff',
      marginTop: '-0.0625rem',
      paddingRight: '1rem',
    },
    transcriptsPanel: {
      background: '#fff',
      overflowY: 'scroll',
      overflowX: 'hidden',
      height: `calc(100% - 3rem)`,
      width: '100%',
      padding: '1rem',
      display: 'flex',
      alignItems: 'flex-start',
      flexDirection: 'column',
      flexWrap: 'nowrap',
    },
    imageWrap: {
      cursor: 'pointer',
      width: '6rem',
      position: 'relative',
      display: 'flex',
      alignItems: 'flex-start',
      marginBottom: '1rem',
    },
    savedScreenshot: {
      display: 'block',
      transition: '0.5s ease',
      borderRadius: '.625rem',
      objectFit: 'cover',
      width: '6rem',
    },
    iconTray: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },
    includeText: {
      marginLeft: '1rem',
      display: 'flex',
      alignItems: 'center',
      fontSize: '0.8rem',
    },
    headerCheckbox: {
      color: COLORS.MEDIUM_GRAY,
      '&.Mui-checked': {
        color: COLORS.PRIMARY,
      },
      padding: '0.125rem',
      '& .MuiSvgIcon-root': { fontSize: '1rem' },
    },
    formControlLabel: {
      margin: 0,
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      '.MuiFormControlLabel-label': {
        display: 'flex',
        alignItems: 'center',
      },
    },
    transcriptBlock: {
      //backgroundColor: '#f7f6ff',
      width: '100%',
      display: 'block',
      position: 'relative',
      flexDirection: 'column',
      transition: 'all 0.2s ease',
      borderRadius: '0.4rem',
      padding: '0 0 1rem 0',
      '&.drag-over': {
        backgroundColor: 'rgba(200, 200, 0, 0.2)',
        border: '0.125rem dashed #f2f0ae',
        borderRadius: '0.4rem',
      },
      '&:hover .transcriptBlockFooter': {
        //display: 'flex',
      },
    },
    transcriptBlockText: {
      fontSize: '.8125rem',
      fontWeight: 500,
      letterSpacing: 'unset',
      lineHeight: '1.5',
      paddingBottom: '1rem',
    },
    transcriptBlockFooter: {
      position: 'absolute',
      bottom: '-0.5rem',
      right: 0,
      display: 'none',
      justifyContent: 'right',
      alignItems: 'center',
      padding: '0.5rem',
      backgroundColor: '#fff',
      border: '.0625rem solid lightgrey',
      borderRadius: '1rem',
      height: '2rem',
      zIndex: 1000,
      boxShadow: '0 .125rem .25rem rgba(0,0,0,0.15)',
    },
    removedText: {
      height: '3rem',
      position: 'absolute',
      left: -5,
      top: 10,
      bottom: 0,
      width: '0.25rem',
      backgroundColor: '#FF0000',
      borderRadius: '0.25rem 0 0 0.25rem',
    },
    transcriptBlockHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      height: '2rem',
    },
    displayTime: {
      fontSize: '0.75rem',
      whiteSpace: 'nowrap',
      minWidth: '10rem',
      textAlign: 'right',
    },
    EditBox: {
      height: 'auto',
      fontSize: '0.8125rem',
      fontWeight: 500,
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#f8f8f8',
      borderRadius: '0.5rem',
    },
    editorPreview: {
      minHeight: '3rem',
      marginTop: '1rem',
    },
    editorPreviewText: {
      color: COLORS.MEDIUM_GRAY,
      marginBottom: '0.5rem',
      fontSize: '0.8rem',
    },
    resetContainer: {
      display: 'flex',
      gap: 1,
      justifyContent: 'flex-end',
      marginTop: 0,
    },
    removedTextItem: {
      height: '100%',
      position: 'absolute',
      left: -5,
      top: 0,
      width: '0.25rem',
      borderRadius: '0.25rem 0 0 0.25rem',
    },
    imageDescription: {
      position: 'absolute',
      top: 0,
      right: 0,
      width: '1rem',
      height: '1rem',
      backgroundColor: 'orange',
      borderRadius: '50%',
      margin: '.25rem',
    },
    popupMenu: {
      position: 'fixed',
      bgcolor: 'background.paper',
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: '4rem',
      width: '7rem',
      zIndex: 1000,
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
    },
    dragIndicator: {
      cursor: 'move',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    popupButtonContainer: {
      width: '0.125rem',
      height: '1.5rem',
      backgroundColor: COLORS.LIGHT_GRAY,
    },
    imagesContainer: {
      flex: '0 0 auto',
      position: 'relative',
      '&:hover .overlay-icons': {
        opacity: 1,
      },
    },
    overlayIcons: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'right',
      alignItems: 'end',
      gap: '0.5rem',
      opacity: 0,
      transition: 'opacity 0.3s',
      backgroundColor: 'rgba(0, 0, 0, 0.25)',
      bottom: 0,
      right: 0,
      borderRadius: '0.625rem',
      padding: '0.2rem',
    },
    overlayIcon: {
      border: '1px solid transparent',
      borderRadius: '.5rem',
      padding: '.25rem',
      '&:hover': {
        border: '1px solid #fff',
      },
    },
    trayButton: {
      cursor: 'pointer',
      borderRadius: '.25rem',
      padding: '.25rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '2rem',
      height: '2rem',
      color: '#888',
      marginRight: '1rem',
      '&:hover': {
        backgroundColor: '#f3f3f3',
      },
    },
    transcriptSegment: {
      position: 'relative',
      marginBottom: '-1rem',
      '&:hover .transcriptBlockFooter': {
        display: 'flex',
      },
    },
    hoverIcon: {
      '&:hover': {
        backgroundColor: '#FFFACD',
      },
    },
  };
};
